import "./Title.css";

type TitleProps = {
  title: string;
  subtitle?: string;
};

export function Title(props: TitleProps) {
  return (
    <div className="titleContainer">
      <h2>{props.title}</h2>
      {props.subtitle && <p>{props.subtitle}</p>}
    </div>
  );
}
